import React from 'react';
import {Modal, Spinner
} from "@shopify/polaris";

type ProgressDisplayModalProps = {
    visible: boolean,
    message: string
}

export default function ProgressDisplayModal({visible, message} : ProgressDisplayModalProps) {

    return (
        <Modal
            open={visible}
            title={message}
            onClose={() => {}}
        >
            <Modal.Section>
                <div className="center-content">
                    <Spinner accessibilityLabel={message} size="large" />
                </div>
            </Modal.Section>
        </Modal>
    );

}